export const predefinedTags = [
  {
    category: "Chameleon",
    tags: ["chameleon", "vibrant reptile", "camouflage", "transformation", "tropical rainforest", "climbing", "journey upward", "vivid greens", "exotic", "lizard", "evolution", "adaptability", "surrealism", "photography", "pop surrealism", "surreal art"]
  },
  {
    category: "Arctic",
    tags: ["arctic animals", "snow fox", "arctic hare", "tundra", "winter scene", "icy landscapes", "serene cold", "snowbound harmony", "frost-covered"]
  },
  {
    category: "Birds",
    tags: [
      "ibis", "elegant bird", "tropical wetlands", "beak", "avian portrait", "detailed feathers", "exotic", "beauty", "graceful bird", "red and white ibis", "swamp bird",
      "starling bird", "misty atmosphere", "ethereal beauty", "foggy setting", "serene tones", "twilight bird", "mist-covered landscape", "calm flight", "dusk stillness", "poetic wildlife",
      "great white pelican", "majestic bird", "wetlands", "large wingspan", "coastal elegance", "aquatic wildlife", "water reflection", "tropical bird", "serene motion", "bill pouch"
    ]
  },
  {
    category: "Big Cats",
    tags: ["leopard", "jungle relaxation", "big cat lounging", "predator resting", "feline grace", "tropical jungle", "golden spots", "wildlife luxury", "elegant", "predator", "untamed beauty"]
  },
  {
    category: "Art Styles",
    tags: ["modern animal portrait", "stylized wildlife", "bold design", "minimalistic", "contemporary art", "wildlife focus", "abstract animal art", "color-blocking", "strong expressions", "artful simplicity"]
  },
  {
    category: "Nature Scenes",
    tags: [
      "animal confrontation", "nature in conflict", "dramatic wildlife", "predator and prey", "fighting stags", "power struggle", "tension", "clash of horns", "symbolic rivalry", "primal energy",
      "surreal entanglement", "nature chaos", "abstract vines", "interconnected forms", "wild vegetation", "organic mystery", "knotted growth", "artistic confusion", "creeping plants", "earthy abstraction"
    ]
  }
]; 